export default __webpack_public_path__ + "static/media/jafal-ashab.7a3446fc.mp3";